
import * as Yup from 'yup'

import { regex } from '../../utils/util';
import { values } from 'lodash';


const headers = [
  {
    label: 'Display Name',
    id: 'display_name'
  },
  {
    label: 'Email',
    id: 'email'
  },
  {
    label: 'Permission Role',
    id: 'role'
  },
  {
    label: "Active",
    id: "is_active",
    boolean: true,
    values: ["Active", "Inactive"]
  },
  {
    label: "Roles",
    id: "roles",
    render: (row) => {
      let roles = []
      if (row.is_stylist) roles.push('STYLIST')
      if (row.is_specialist) roles.push('SPECIALIST')
      return roles.join(', ')
    }
  },
  {
    label: 'Created At',
    date: true,
    id: 'created_at'
  }
];

const filters = [
  {
    id: "created_at",
    type: "date",
    label: "Created At",
  },
  {
    id: "is_active",
    type: "boolean",
    label: "Active",
  }
]

const initialValues = {
  first_name: "",
  last_name: "",
  display_name: "",
  email: "",
  role_id: "",
  password: "",
  confirm_password: "",
  is_active: true,
  is_stylist: true,
  is_specialist: false
}

const fields = [
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "first_name",
    label: "First Name",
    // required: true,
    type: "text",
    size: {xs: 12, lg: 6},
  },
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "last_name",
    label: "Last Name",
    type: "text",
    size: {xs: 12, lg: 6},
  },
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "display_name",
    label: "Display Name",
    // required: true,
    type: "text",
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "email",
    label: "Email",
    required: true,
    type: "email",
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "formField",
    formFieldType: "select",
    options: [],
    name: "role_id",
    label: "Select Role",
    defaultValue: "",
    required: true,
    type: "text",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: 'divider',
    name: 'set_password',
    size: {xs: 12, lg: 12},
    header: 'Set Password',
    checkDisplayField: (values) => { return !values?.user_id}
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "password",
    label: "Password",
    // placeholder: "Enter Password",
    required: false,
    type: "password",
    size: {xs: 12, lg: 4},
    checkDisplayField: (values) => { return !values?.user_id}
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "confirm_password",
    label: "Confirm Password",
    // placeholder: "Confirm Password",
    required: false,
    type: "password",
    size: {xs: 12, lg: 4},
    checkDisplayField: (values) => { return !values?.user_id}
  },
  {
    fieldType: "formField",
    formFieldType: "switch",
    name: "is_active",
    label: "Active",
    // placeholder: "Confirm Password",
    // required: true,
    type: "checkbox",
    size: {xs: 12, lg: 4},
  },
  {
    fieldType: 'divider',
    size: {xs: 12, lg: 12},
    name: 'stylist_settings',
    header: 'Stylist Settings',
    checkDisplayField: (values) => { return !values?.user_id}
  },
  {
    fieldType: "formField",
    formFieldType: "switch",
    name: "is_stylist",
    label: "User is Stylist",
    type: "checkbox",
    helperText: 'Toggle on if user should have a calendar view and be able to book appointments',
    checkDisplayField: (values) => { return !values?.user_id},
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "formField",
    formFieldType: "switch",
    name: "is_specialist",
    label: "User is a Repair Specialist",
    type: "checkbox",
    helperText: 'Toggle on if user is a repair specialist',
    checkDisplayField: (values) => { return !values?.user_id},
    size: {xs: 12, lg: 6},
  }
]

const schema = Yup.object().shape({
  first_name: Yup.string().when(['is_stylist', 'is_specialist'], {
    is: true,
    then: (schema) => schema.required("First Name is required").min(3).max(30),
    otherwise: (schema) => schema.notRequired()
  }),
  display_name: Yup.string().when('password', {
    is: (value) => value,
    then: (schema) => schema.required().min(3).max(30),
    otherwise: (schema) => schema.notRequired()
  }),
  email: Yup.string().email('Invalid email').required('Email is required'),
  role_id: Yup.string().required('Role is required'),
  password: Yup.string().matches(regex, 'Password must be eight characters with at least one uppercase letter and a number'),
  confirm_password: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match'),
});

export { filters, headers, fields, initialValues, schema };
